




























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Pagination extends Vue {
  limits = [
    { id: 1, value: 5 },
    { id: 2, value: 15 },
    { id: 3, value: 50 },
  ];
  limit: number = 0;

  @Prop({ default: 10, type: Number }) totalVisible?: number;
  @Prop({ default: 10, type: Number }) totalCount?: number;
  @Prop({ default: 15, type: Number }) limitSelected!: number;
  @Prop({ default: 1, type: Number }) currentPage!: number;

  async mounted() {
    this.limit = this.limitSelected;
  }

  get roundCountPage() {
    return this.totalCount && this.limit > 0
      ? Math.ceil(this.totalCount / this.limit)
      : 0;
  }

  get page() {
    return this.currentPage;
  }

  set page(val: number) {
    this.$emit('changePage', val);
  }

  onChangeLimit(limit: number) {
    this.limit = limit;
    this.$emit('changeLimit', limit);
  }
}
